import { HelpItemType } from "../constants";

function getFunctionRelatedItems(item, calculatedFields) {
    if (!item || !item.Related || item.Related.length === 0) {
        return [];
    }

    return item.Related.map(relatedItem => {
        return {
            Id: getSlugFromId(relatedItem.RelatedResourceId, calculatedFields),
            Name: relatedItem.Name,
            Type: HelpItemType.Function //there is a type prop but what type is which?
        };
    });
}

function getSlugFromId(id, calculatedFields) {
    for (const category of calculatedFields) {
        for (const func of category.Functions) {
            if (func.FunctionId === id) {
                return func.Slug;
            }
        }
    }
}

function normalizeArticles (articles) {
    if (!articles) return [];

    return articles.map(item => {
        return {
            Id: item.link,
            Name: item.name,
            Description: item.summary
        };
    });
}

function getHelpItemFromPath(path, articles) {
    let target = articles;

    for (const pathItem of path) {
        const helpItem = getHelpItem(pathItem, target);

        if (helpItem.length > 0) {
            target = helpItem;
        } else {
            return helpItem;
        }
    }

    return target;
}

function getHelpItem(slug, items) {
    const index = items.findIndex(item => item.Slug === slug);
    if (index === -1) return [];
    return items[index]?.Children;
}

export { getFunctionRelatedItems, normalizeArticles, getHelpItemFromPath, getHelpItem }